module.exports = __webpack_public_path__ + "fe28c328ebaa29830e110e7b8a068da0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-s.png
// module id = 2023
// module chunks = 0